import React from 'react';
import './ConversationStarters.css';

const ConversationStarters = ({ starters, onSelect }) => {
  if (!starters.length) return null;
  return (
    <section className="conversation-starters" aria-labelledby="conversation-starters-heading">
      <h2 id="conversation-starters-heading" className="starter-heading">Try asking about</h2>
      <ul className="starter-list">
        {starters.map((starter, index) => (
          <li key={index}>
            <button
              type="button"
              className="starter-item"
              onClick={() => onSelect(starter)}
              title={starter}
            >
              <i className="bi bi-chat-left-text starter-icon" aria-hidden="true"></i>
              <span className="starter-text">{starter.trim()}</span>
              <i className="bi bi-pencil starter-hint" aria-hidden="true"></i>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ConversationStarters;
